import { asGroupedFieldOptionsForFilter } from 'module/helpers/filter/grouped-field-transformer';
import { useTranslate } from 'module/hooks/use-translation';
import { GroupedFilter } from 'module/types/filter-field/grouped-filter/filter';
import { FilterGroupType } from 'module/types/filter-field/grouped-filter/group';
import { ApiFilterTransformer } from 'module/ui/components/molecules/field-filter/filter-transformation/api-filter-transformer';
import { MeetingPageTemplateUiState } from 'api/meeting-page-template/types';
import { PageType, SourceType, TiptapJson } from 'api/page-template/types';
import { useCompanyFieldsAsFilterableField } from 'helpers/fields/company-fields/fields';
import { useMeetingFieldsAsFilterableField } from 'helpers/fields/meeting-fields/fields';
import { BaseTemplatePage } from '../shared/base-template';
import { defaultContent } from '../utils';

export const MeetingTemplatePage = ({
  templateData,
  onTemplateChange,
  groupedTransformer,
  previousTiptapJson,
  isModuleFed = false,
  readOnlyTemplateConditions,
}: {
  templateData?: MeetingPageTemplateUiState;
  onTemplateChange: (payload: Partial<MeetingPageTemplateUiState>) => void;
  groupedTransformer?: ApiFilterTransformer<GroupedFilter>;
  previousTiptapJson?: TiptapJson;
  isModuleFed?: boolean;
  /** Federated read-only (e.g. `!canWrite`); when set, template conditions UI is read-only. */
  readOnlyTemplateConditions?: boolean;
}) => {
  const { fields: companyFields } = useCompanyFieldsAsFilterableField();
  const { fields: meetingFields } = useMeetingFieldsAsFilterableField();
  const groupedFields = asGroupedFieldOptionsForFilter(
    {
      [FilterGroupType.Company]: {
        fields: companyFields,
      },
      [FilterGroupType.Meeting]: {
        fields: meetingFields,
      },
    },
    useTranslate(),
  );

  return (
    <BaseTemplatePage<PageType.Meeting, SourceType.Meeting>
      pageType={PageType.Meeting}
      templateData={templateData}
      groupedFields={groupedFields}
      groupedTransformer={groupedTransformer}
      onTemplateChange={onTemplateChange}
      defaultContent={defaultContent}
      isModuleFed={isModuleFed}
      previousTiptapJson={previousTiptapJson}
      readOnlyTemplateConditions={readOnlyTemplateConditions}
    />
  );
};
